import { Guid } from '@web/utils';
import { PublicProductCompositePaymentPeriod } from '../enums/public-product-composite-payment-period';
import { PublicSales } from '@web/shared/module/shop';

export class PublicProductCompositeCollectionItem {
  public constructor(
    private readonly data: {
      id: Guid;
      name: string;
      headline: string;
      price: number;
      paymentPeriod: PublicProductCompositePaymentPeriod;
      description: string;
      sales: PublicSales;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get headline(): string {
    return this.data.headline;
  }

  public get name(): string {
    return this.data.name;
  }

  public get price(): number {
    return this.data.price;
  }

  public get paymentPeriod(): PublicProductCompositePaymentPeriod {
    return this.data.paymentPeriod;
  }

  public get description(): string {
    return this.data.description;
  }

  public get sales(): PublicSales {
    return this.data.sales;
  }
}
